import { z } from "zod";

export const SessionStatus = z.enum(["stopped", "running", "paused"]);
export type SessionStatus = z.infer<typeof SessionStatus>;

export const SessionLog = z.object({
  id: z.string().uuid(),
  session_id: z.string().uuid(),
  action: z.enum(["start", "pause", "resume", "stop"]),
  elapsed_ms: z.number(),
  created_at: z.string(),
});
export type SessionLog = z.infer<typeof SessionLog>;

export const Session = z.object({
  id: z.string().uuid(),
  name: z.string(),
  status: SessionStatus,
  created_at: z.string(),
  updated_at: z.string(),
});
export type Session = z.infer<typeof Session>;

export const SessionWithLogs = Session.extend({
  logs: z.array(SessionLog),
});
export type SessionWithLogs = z.infer<typeof SessionWithLogs>;

export const CreateSessionRequest = z.object({
  name: z.string().min(1),
});
export type CreateSessionRequest = z.infer<typeof CreateSessionRequest>;

export const ElapsedRequest = z.object({
  elapsed_ms: z.number().nonnegative(),
});
export type ElapsedRequest = z.infer<typeof ElapsedRequest>;

export const SessionList = z.array(Session);
export type SessionList = z.infer<typeof SessionList>;
